module.exports = __webpack_public_path__ + "media/images/icons/youtube-dark-21610d7877639080f8b74337da2b2d54.svg";